import { auditFields, operations, types } from '../common';

/**
 * Entity schema
 */
const schema = {
  version: 0,

  title: 'Cross matching',
  description: 'Blood product matching with transfusion',

  primaryKey: 'id',
  type: 'object',
  properties: {
    id: types.ID,
    icode: types.STRING_INDEX,

    isMatch: types.BOOLEAN,
    status: types.STRING_INDEX, // activity
    details: types.STRING,

    bloodBank: types.OBJECT,
    bloodProduct: types.OBJECT,
    transfusion: types.OBJECT,

    consumables: types.ARRAY,
    equipments: types.ARRAY,
    healthCareWorkers: types.ARRAY,

    // Audit fields
    ...auditFields
  },

  required: ['id', 'status', 'bloodBank', 'bloodProduct', 'transfusion'],
  indexes: [],
  keyCompression: true
};

/**
 * Migration strategies
 */
const migrationStrategies = {};

/**
 * Collection methods
 */
const statics = {
  /**
   * Creates new instance
   *
   * Also updates full and person names
   *
   * @param {object} data  New instance
   * @returns Promise
   */
  add: function (data) {
    return operations.add(this, data);
  },

  /**
   * Updates instance
   *
   * Also updates full and person names
   *
   * @param {object} data  Instance
   * @returns Promise
   */
  edit: function (data) {
    return operations.edit(this, data);
  },

  /**
   * Deletes instance
   *
   * @param {string} id  Instance ID
   * @returns Promise
   */
  del: function (id) {
    return operations.del(this, id);
  }
};

/**
 * Instance methods
 */
const methods = {};

/**
 * Collection definition
 */
const collection = { schema, migrationStrategies, statics, methods };

export default collection;
